export const LESSONS_LEARNING_SECTIONS = {
  SECTOR_FRAMEWORK: 'sector--thematic-frameworks',
  CURATED_LESSON: 'curated-lesson',
  PROJECT_COMPLETION: 'project-completion-reports',
  IDB_PUBLICATIONS: 'idb-publications',
  COUNTRY_STRATEGIES: 'country-strategies',
  LOAN_PROPOSAL: 'loan-proposal',
  OPERATIONAL_EXERCISES: 'operational-exercises',
} as const;

export const SECTION_ORDER: readonly string[] = [
  LESSONS_LEARNING_SECTIONS.SECTOR_FRAMEWORK,
  LESSONS_LEARNING_SECTIONS.CURATED_LESSON,
  LESSONS_LEARNING_SECTIONS.PROJECT_COMPLETION,
  LESSONS_LEARNING_SECTIONS.IDB_PUBLICATIONS,
  LESSONS_LEARNING_SECTIONS.COUNTRY_STRATEGIES,
  LESSONS_LEARNING_SECTIONS.LOAN_PROPOSAL,
  LESSONS_LEARNING_SECTIONS.OPERATIONAL_EXERCISES,
] as const;

export const SECTION_LABELS: Record<string, string> = {
  [LESSONS_LEARNING_SECTIONS.SECTOR_FRAMEWORK]:
    'KNOWLEDGE.PILLS_LESSON_LEARNING.SECTOR_FRAMEWORK_DOCUMENT',
  [LESSONS_LEARNING_SECTIONS.CURATED_LESSON]: 'KNOWLEDGE.PILLS_LESSON_LEARNING.CURATED_PCR_LESSONS',
  [LESSONS_LEARNING_SECTIONS.PROJECT_COMPLETION]:
    'KNOWLEDGE.PILLS_LESSON_LEARNING.PROJECT_COMPLETION_REPORT',
  [LESSONS_LEARNING_SECTIONS.IDB_PUBLICATIONS]: 'KNOWLEDGE.PILLS_LESSON_LEARNING.IDB_PUBLICATIONS',
  [LESSONS_LEARNING_SECTIONS.COUNTRY_STRATEGIES]:
    'KNOWLEDGE.PILLS_LESSON_LEARNING.COUNTRY_STRATEGIES',
  [LESSONS_LEARNING_SECTIONS.LOAN_PROPOSAL]: 'KNOWLEDGE.PILLS_LESSON_LEARNING.LOAN_PROPOSALS',
  [LESSONS_LEARNING_SECTIONS.OPERATIONAL_EXERCISES]:
    'KNOWLEDGE.PILLS_LESSON_LEARNING.OPERATIONAL_EXERCISES',
};

export const ACTIVE_CATALOGUE_TAB_KEY = 'lessonsCatalogueActiveTab';
